import { Component, SimpleChanges, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { appUtil } from 'clink-ui-x/utils';
import * as moment from 'moment';

@Component({
    selector: 'clink-customize-time-picker',
    templateUrl: './customize-time-picker.component.html',
    styleUrls: ['./customize-time-picker.component.less'],
})
export class CustomizeTimePickerComponent implements OnChanges {
    @Input() initialTime: any; // 初始日期
    @Input() disabled = false; // 当前组件是否禁用
    @Input() placeHolder = '请选择'; // 提示文字
    @Input() showFormat = 'HH:mm:ss'; // 展示日期格式
    @Input() updateFormat = 'HH:mm:ss'; // 更新日期数据的格式
    @Input() use12Hours = true; // 是否使用12小时制
    @Input() minuteStep = 5; // 分钟选项间隔
    @Input() secondStep = 5; // 秒选项间隔
    @Input() isError = false; // 当前对应控件是否有错误
    @Input() errorExpression = '必填项！'; // 错误提示语
    @Input() nzSize = 'small';
    @Output() updateTime: EventEmitter<any> = new EventEmitter();
    showTimeValue: Date | null = null; // 展示时间

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        // 初始时间变更
        if (changes.initialTime) {
            if (changes.initialTime.currentValue) {
                const dateValue = moment().format('YYYY/MM/DD');
                // 时间字段需要拼接成完整日期
                const formatValue = `${dateValue} ${changes.initialTime.currentValue}`;
                this.showTimeValue = appUtil.handleTimeDateValue(formatValue);
            } else {
                this.showTimeValue = null;
            }
        }
    }

    /**
     * 更新时间
     */
    updateTimeValue(event: Date): void {
        if (event) {
            // Date 对象转换为时间戳
            const newDateValue = event.valueOf();
            const newValue = moment(newDateValue).format(this.updateFormat);
            this.updateTime.emit(newValue);
        }
    }

    /**
     * 面板打开/关闭时的回调
     */
    nzOpenChange(ev: boolean): void {
        if (!ev) {
            return;
        }
        setTimeout(() => {
            const timerEl = document.getElementById('__timepicker');
            if (timerEl) {
                const { y, height } = timerEl.getBoundingClientRect();
                const isBottom = document.documentElement.clientHeight - height - y - 273 < 0;
                if (isBottom) {
                    // document.getElementsByClassName('ant-picker-dropdown ng-trigger-slideMotion').item(0)['style'].bottom = '30px';
                }
            }
        });
    }
}
